<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    {{ $route.meta.title }}
                </div>
                <div class="list-content">
                    <ssam-talk-write-component :ssam-talk-type="'ssamtalkCreate'" :setViewData="setViewData"></ssam-talk-write-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import SsamTalkWriteComponent from "@/components/ssamtalk/SsamTalkWriteComponent.vue";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "SsamTalkContentCreate",
    mixins: [alertMixins],
    components: {SsamTalkWriteComponent},
    provide() {
        return {
            setShowTab: this.setShowTab,
        };
    },
    props: {},
    data() {
        return {
            stepStatus: 0,
            isShowTab: false,
        };
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setShowTab(value) {
            this.isShowTab = value;
        },
        save() {
            if(this.stepStatus === 0) {
                this.createConfirm({
                    content: '기존 입력한 정보 기반으로 최종 제출하며 이후에 수정 불가능합니다. 저장하시겠습니까?',
                    confirm: () => {
                        EventBus.$emit('writeSsamTalk');
                    }
                })
            }else {
                EventBus.$emit('writeSsamTalk');
            }
        },
        setViewData(type, value) {
            if(type == 'stepStatus') {
                this.stepStatus = value;
            }
        }
    },
    watch: {},
};
</script>
